import { CheckboxField, SelectField } from "../../../ui/fields";
import { outcomeFilterOptions, processingFilterOptions, type RowOutcome } from "../labels";
import type { ReviewFilter } from "../queries";

type FilterBarProps = Readonly<{
  filter: ReviewFilter;
  mode: "review" | "processing";
  onChange: (filter: ReviewFilter) => void;
}>;

const isOutcome = (value: string): value is RowOutcome =>
  outcomeFilterOptions.some((option) => option.value === value);
const processingOf = (value: string) =>
  processingFilterOptions.find((option) => option.value === value)?.value ?? null;

/** The status filter and the "needs a decision" filter (review), or the result filter (processing). */
export function FilterBar({ filter, mode, onChange }: FilterBarProps) {
  return (
    <fieldset className="m-0 flex min-w-0 flex-wrap items-end gap-4 border-0 p-0">
      <legend className="sr-only">Filter the rows</legend>
      {mode === "review" ? (
        <>
          <div className="min-w-48">
            <SelectField
              id="review-filter-outcome"
              label="Status"
              value={filter.outcome ?? ""}
              options={outcomeFilterOptions}
              placeholder="All rows"
              onChange={(value) =>
                onChange({ ...filter, outcome: isOutcome(value) ? value : null })
              }
            />
          </div>
          <CheckboxField
            id="review-filter-needs-decision"
            label="Only rows that need a decision"
            checked={filter.needsDecision}
            onChange={(checked) => onChange({ ...filter, needsDecision: checked })}
          />
        </>
      ) : (
        <div className="min-w-48">
          <SelectField
            id="review-filter-processing"
            label="Result"
            value={filter.processing ?? ""}
            options={processingFilterOptions}
            placeholder="All rows"
            onChange={(value) => onChange({ ...filter, processing: processingOf(value) })}
          />
        </div>
      )}
    </fieldset>
  );
}
